(function ($, Cobalt, undefined) {
    Cobalt.Filters = {

        initialize: function () {
            $(document).ready(function () {
                $("form.j-filters").each(function () { SetupFiltersForm($(this)); });

                function SetupFiltersForm(form) {
                    var Form = form;
                    var ClearAllButton = $("#clear-all-filters");

                    Form.submit(function () { OnSubmit($(this)); return false; });

                    /* Set up right-side checkbox lists, which are nothing more than bitmasks. */
                    Form.find("fieldset[data-bitmask-name]").each(function () { SetupBitmaskCheckboxes($(this)); });

                    ClearAllButton.click(function () {
                        var dynamicFilters = $("#dynamic-filters");

                        if (dynamicFilters && dynamicFilters.length > 0)
                            dynamicFilters.data("clear-all")();

                        Form.find("fieldset[data-bitmask-name]").each(function () { $(this).data("clear-all")(); });
                        Form.find("input[type=text]:not(.chosen-container-multi input),input[type=search],select").val(null).attr("checked", null);
                        Form.find(".search-choice-close").click();
                    });

                    function OnSubmit() {
                        var dynData = null,
                            bitmaskData = {},
                            formData = $(".j-filters").find("input, select, textarea").filter(":not([data-bitmask-name] *, [value=\"\"])").serialize() || "",
                            queryData = GetUrlParams();

                        var dynamicFilters = $("#dynamic-filters");

                        if (dynamicFilters.length > 0) {
                            dynData = dynamicFilters.data("serialize")();
                        }

                        /* Add bitmasks */
                        Form.find("fieldset[data-bitmask]").each(function () {
                            var name = $(this).attr("data-bitmask-name");
                            var value = parseInt($(this).attr("data-bitmask"));

                            if (name && value) {
                                bitmaskData[name] = value;
                            }
                        });

                        if (!$.isEmptyObject(dynData)) {
                            formData += (formData.length ? "&" : "") + $.param(dynData);
                        }

                        if (!$.isEmptyObject(bitmaskData)) {
                            formData += (formData.length ? "&" : "") + $.param(bitmaskData);
                        }

                        if (queryData.sort) {
                            formData += (formData.length ? "&" : "") + "sort=" + queryData.sort;
                        }

                        if (queryData.display) {
                            formData += (formData.length ? "&" : "") + "display=" + queryData.display;
                        }

                        var baseUrl = location.href;

                        if (location.href.indexOf("?") != -1)
                            baseUrl = location.href.substr(0, location.href.indexOf("?"));

                        var finalUrl = baseUrl + (formData.length ? "?" + formData : "");

                        location.href = finalUrl.replace(/%5B%5D/g, "");
                    }

                    function SetupBitmaskCheckboxes(container) {
                        var Bitmask = parseInt(container.attr("data-bitmask"));
                        var DeleteButton = container.find(".delete-button");
                        var IsAlreadyBitmask = container.attr("data-isbitmask") == "true";

                        container.find("input[type=checkbox]").change(function () { OnCheckboxChange($(this)); }).change();
                        container.data("clear-all", function () {
                            container.find("input[type=checkbox]").each(function () {
                                $(this).attr("checked", null);
                                OnCheckboxChange($(this));
                            });
                        });

                        function OnCheckboxChange(checkbox) {
                            var value = parseInt(checkbox.val());

                            if (checkbox.attr("checked"))
                                ChangeBit(value, true);
                            else
                                ChangeBit(value, false);
                        }

                        function ChangeBit(bit, set) {
                            var bitmask = Bitmask;

                            if (bit < 1)
                                return;

                            if (IsAlreadyBitmask) {
                                if (set)
                                    bitmask |= bit;
                                else
                                    bitmask &= ~bit;
                            }
                            else {
                                if (set)
                                    bitmask |= (1 << (bit - 1));
                                else
                                    bitmask &= ~(1 << (bit - 1));
                            }

                            if (bitmask != Bitmask) {
                                Bitmask = bitmask;
                                container.attr("data-bitmask", Bitmask);

                                if (Bitmask == 0)
                                    DeleteButton.hide();
                                else
                                    DeleteButton.show();
                            }
                        }

                        DeleteButton.click(function () {
                            Bitmask = 0;
                            container.attr("data-bitmask", 0);
                            container.find("input[type=checkbox]").attr("checked", null);
                            DeleteButton.hide();
                        });
                    }
                }
            });
        }
    };
})(jQuery, Cobalt);




/* All the code for Dynamic Filters is here. */
function GetUrlParams() {
    /* Load up URL params */
    var urlParams = {};
    (function () {
        var match,
        pl = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
        query = window.location.search.substring(1);

        while (match = search.exec(query))
            urlParams[decode(match[1])] = decode(match[2]);
    })();

    return urlParams;
}

function DynamicFilters(Filters) {
    var Container = $("#dynamic-filters");
    var FiltersByName = {};

    var FilterHandlers = {
        'yn': YesNoHandler,
        'dropdown': DropdownHandler,
        'dropdown2': Dropdown2Handler,
        'range': RangeHandler,
        'num': NumHandler,
        'string': StringHandler,
        'simplenum': SimpleNumHandler,
        'symbolic': SymbolicHandler,
        'openum': OpEnumHandler
    };
    var SerializeHandlers = {
        'num': SerializeNum,
        'dropdown2': SerializeDropdown2,
        'range': SerializeRange,
        'symbolic': SerializeSymbolic,
        'openum': SerializeNum
    };
    var DeserializeHandlers = {
        'num': DeserializeNum,
        'dropdown2': DeserializeDropdown2,
        'range': DeserializeRange,
        'symbolic': DeserializeSymbolic,
        'openum': DeserializeNum
    };

    Container.data("clear-all", function () { ClearAll() });
    Container.data("serialize", function () { return Serialize(); });
    Initialize();

    function Initialize() {
        /* Cache for filters by name */
        for (var categoryName in Filters) {
            var filters = Filters[categoryName];
            for (var i = 0; i < filters.length; ++i)
                FiltersByName[filters[i].Name] = filters[i];
        }

        Container.html("");
        Deserialize();
        AddMainDropdown();
        Container.find("select").chosen();
    }

    /* Adds a <select> containing all the filters. selecetedFilterName is optional. */
    function AddMainDropdown(selectedFilterName) {
        var dropdown = $("<select data-placeholder=\"Add a filter...\" />").addClass("main");
        dropdown.append($("<option></option>"));
        var firstCategory = true;

        for (var categoryName in Filters) {
            var filters = Filters[categoryName];
            var category = $("<optgroup/>").attr("label", categoryName);

            for (var i = 0; i < filters.length; ++i) {
                var data = filters[i];
                var option = $("<option/>").text(data.Label).data("filter", data).attr("data-name", data.Name);

                if (selectedFilterName && data.Name == selectedFilterName)
                    option.attr("selected", "selected");

                category.append(option);
            }

            if (firstCategory)
                firstCategory = false;
            else
                category.css("padding-top", "15px");

            dropdown.append(category);
        }

        dropdown.data("last-value", dropdown.val());
        dropdown.change(function () { OnDropdownChange($(this)); });
        dropdown.keyup(function () { OnDropdownChange($(this)); });

        var container = $("<div/>");
        container.append(dropdown);

        Container.append(container);

        if (selectedFilterName)
            OnDropdownChange(dropdown, true);

        container.find("select.main").chosen({ allow_single_deselect: true });
        container.find(".chosen-container").first().addClass("main");

        return container;
    }

    /* Called every time the main dropdown containing all the filters changes value. */
    function OnDropdownChange(dropdown, alwaysExecute) {
        var wasEmpty = dropdown.data("last-value") == "";

        if (!alwaysExecute && dropdown.val() == dropdown.data("last-value"))
            return;
        dropdown.data("last-value", dropdown.val());

        /* First thing: clean up the inputs and selects after the dropdown, to start from a "clean state". */
        dropdown.parent().find("select:not(.main), .chosen-container:not(.main), input:not(.chosen-container, .chosen-container *), span:not(.chosen-container, .chosen-container *), div:not(.chosen-container, .chosen-container *)").remove();

        /* Now set up the filter (if it exists). */
        var filter = dropdown.find(":selected").data("filter");
        if (filter) {
            CreateFilter(dropdown.parent(), filter);

            if (!alwaysExecute)
                dropdown.parent().find("select").chosen();
        }

        /* Now add a new dropdown if needed! */
        if (wasEmpty)
            AddMainDropdown();

        /* Delete if it wasn't empty but now is. */
        if (!wasEmpty && dropdown.val() == "")
            dropdown.parent().remove();
    }

    /* Creates the filter controls. Called whenever a filter is selected in OnDropdownChange. */
    function CreateFilter(row, filter) {
        var handler = FilterHandlers[filter.Type] || DefaultHandler;
        row.append(" ");
        handler(row, filter);
        row.append(" ");

        Cobalt.triggerHtmlInsert(row);
    }

    /*********************** HANDLERS HERE (1 per filter type) ***********************/
    function DefaultHandler(row, filter) {
        var errorMessage = $("<span/>").addClass("error").text("Internal Error - Unknown filter type: " + filter.Type);

        row.append(errorMessage);
    }

    function YesNoHandler(row, filter) {
        var select = $("<select/>");

        select.append($("<option/>").attr("value", 1).text("Yes"));
        select.append($("<option/>").attr("value", 0).text("No"));

        row.append(select);
        select.css("width", "65px").addClass("filter-input");
    }

    function SymbolicHandler(row, filter) {
        var input = $("<input>").attr("type", "text");
        input.attr("data-autocomplete-url", filter.AutocompleteURL);
        input.attr("id", filter.ID);
        input.addClass("ac_input");

        if (filter.Watermark) {
            $(input).watermark(filter.Watermark);
        }

        var symbolicInput = $("<input>").attr("type", "hidden");
        symbolicInput.attr("id", filter.ID + "-symbol");
        row.append(symbolicInput);

        var previousInput = $("<input>").attr("type", "hidden");
        previousInput.attr("id", filter.ID + "-previous");
        row.append(previousInput);

        row.append(input);
    }

    function GetSelectForDropdownFilter(values, filter) {
        var select = $("<select/>");

        var arr = [];

        var idx = 0;
        for (var value in values) {
            if (values[value] != " - ")
                arr.push({ Value: value, Name: values[value], Idx: idx++ });
        }

        arr = arr.sort(function (a, b) {
            // "Any" and "All" should always be on top. "None" should always be on bottom.
            if (a.Name == "Any")
                return -1;
            if (b.Name == "Any")
                return 1;

            if (a.Name == "None" || a.Name == "All")
                return 1;
            if (b.Name == "None" || b.Name == "All")
                return -1;

            return a.Name < b.Name ? -1 : 1;
        });

        for (var i = 0; i < arr.length; ++i) {
            var option = $("<option/>").attr("value", arr[i].Value).text(arr[i].Name);

            if (arr[i].Classes) {
                for (var y = 0; y < arr[i].Classes.length; ++y)
                    option.addClass(arr[i].Classes[y]);
            }

            select.append(option);
        }

        if (filter && filter.Classes) {
            for (var y = 0; y < filter.Classes.length; ++y) {
                if (filter.Classes[y] == "is-chosen-select") {
                    select.attr("data-dropdown", "child");
                }

                select.addClass(filter.Classes[y]);
            }
        }

        return select;
    }

    function DropdownHandler(row, filter) {
        var dropdown = GetSelectForDropdownFilter(filter.Values, filter);
        dropdown.addClass("filter-input");
        row.append(dropdown);
    }

    function Dropdown2Handler(row, filter) {
        for (var valueNum = 0; valueNum < filter.Values.length; ++valueNum) {
            var select = GetSelectForDropdownFilter(filter.Values[valueNum]);
            select.attr("data-value-id", valueNum + 1);
            row.append(select).append(" ");
        }
    }

    function RangeHandler(row, filter) {
        var minInput = $("<input/>").addClass("numeric").attr("type", "text").addClass("j-min-value");
        var maxInput = $("<input/>").addClass("numeric").attr("type", "text").addClass("j-max-value");

        row.find(".j-min-value, .j-max-value, .j-separator");

        row.append(minInput).append("<span class=\"j-separator\">to<span>").append(maxInput);
    }

    function NumHandler(row, filter) {
        var comparatorSelect = $("<select/>").addClass("j-comparator");

        comparatorSelect.append($("<option/>").attr("value", 1).text(">"));
        comparatorSelect.append($("<option/>").attr("value", 2).text(">="));
        comparatorSelect.append($("<option/>").attr("value", 3).text("="));
        comparatorSelect.append($("<option/>").attr("value", 4).text("!="));
        comparatorSelect.append($("<option/>").attr("value", 5).text("<="));
        comparatorSelect.append($("<option/>").attr("value", 6).text("<"));

        var numInput = $("<input/>").addClass("numeric").attr("type", "text").addClass("j-value");



        if (filter.Classes) {
            for (var y = 0; y < filter.Classes.length; ++y)
                numInput.addClass(filter.Classes[y]);
        }

        if (numInput.hasClass("cerulean-calcstat")) {

            var natureSelect = $("<select/>").addClass("j-nature");

            natureSelect.append($("<option/>").attr("value", 1).text("+ 0%"));
            natureSelect.append($("<option/>").attr("value", 2).text("+ 10%"));
            natureSelect.append($("<option/>").attr("value", 3).text("- 10%"));
            row.append(comparatorSelect).append(" ").append(numInput).append(" ").append(natureSelect);
        }
        else {
            row.append(comparatorSelect).append(" ").append(numInput);
        }
        if ($(numInput).hasClass("j-currency-filter")) {
            $("<span>").text("$").insertBefore($(numInput));
        }
        if (filter.Watermark) {
            $(numInput).watermark(filter.Watermark);
        }
    }

    function OpEnumHandler(row, filter) {
        var comparatorSelect = $("<select/>").addClass("j-comparator");

        comparatorSelect.append($("<option/>").attr("value", 3).text("Is"));
        comparatorSelect.append($("<option/>").attr("value", 4).text("Is Not"));

        row.append(comparatorSelect);

        var dropdown = GetSelectForDropdownFilter(filter.Values, filter).attr('id', filter.Name).addClass("j-value");
        dropdown.addClass("filter-input");
        row.append(dropdown);
    }


    function SimpleNumHandler(row, filter) {
        var inputText = $("<input/>").attr("type", "text").addClass("numeric");
        inputText.addClass("filter-input");
        row.append(inputText);
    }

    function StringHandler(row, filter) {
        var inputText = $("<input/>").attr("type", "text");
        inputText.addClass("filter-input");
        row.append(inputText);
    }

    function ClearAll() {
        Container.find("select.main").each(function () {
            if ($(this).find(":selected").data("filter"))
                $(this).parent().remove();
        });
    }

    /*********************** Serialization / Deserialization ***********************/
    function Serialize() {
        var data = {};

        /* For each dropdown.. */
        Container.find("select.main").each(function () {
            var filter = $(this).find(":selected").data("filter");
            var row = $(this).parent();

            if (!filter)
                return;

            SerializeFilter(data, filter, row);
        });

        return data;
    }

    function SerializeFilter(data, filter, row) {
        var handler = SerializeHandlers[filter.Type] || SerializeDefault;

        handler(data, filter, row);
    }

    function SerializeDefault(data, filter, row) {
        var val = row.find(".filter-input").val();

        if (val)
            data["filter-" + filter.Name] = val;
    }

    function SerializeSymbolic(data, filter, row) {
        var symbolicVal = row.find("#filter-" + filter.Name + "-symbol").val();
        var previousVal = row.find("#filter-" + filter.Name + "-previous").val();
        var currentVal = row.find("#filter-" + filter.Name).val();
        if (!filter.TextSearchOnly) {
            if (symbolicVal) {
                data["filter-" + filter.Name + "-symbol"] = symbolicVal;
                data["filter-" + filter.Name + "-previous"] = previousVal;
            }
            else {
                data["filter-" + filter.Name + "-previous"] = currentVal;
            }
        }
        data["filter-" + filter.Name] = currentVal;
    }

    function SerializeDropdown2(data, filter, row) {
        var isEnum = false;
        if (filter.Classes && filter.Classes.length > 0) {
            if ($.inArray("cerulean-enum", filter.Classes) > -1) {
                isEnum = true;
            }
            else {

            }
        }
        if (isEnum) {
            var holder = row.find("select[data-value-id]");
            data["filter-" + filter.Name + "-val1"] = $(holder[0]).val();
            data["filter-" + filter.Name + "-op"] = $(holder[1]).val();
            data["filter-" + filter.Name + "-val2"] = $(holder[2]).val();
        }
        else {
            row.find("select[data-value-id]").each(function () {
                data["filter-" + filter.Name + "-" + $(this).attr("data-value-id")] = $(this).val();
            });
        }
    }

    function SerializeRange(data, filter, row) {
        var minVal = row.find(".j-min-value").val();
        var maxVal = row.find(".j-max-value").val();

        if (minVal)
            data["filter-" + filter.Name + "-min"] = minVal;
        if (maxVal)
            data["filter-" + filter.Name + "-max"] = maxVal;
    }

    function SerializeNum(data, filter, row) {
        var comparator = row.find(".j-comparator").val();
        var valueInput = row.find(".j-value");
        var value = valueInput.val();

        if (valueInput.hasClass("cerulean-height")) {
            var match = value.match(/^[0-9]+ ?(\'|ft|cm|meters|feet|in|inches|\")?( *[0-9]+ ?(\"|inches|in|cm)?)?$/);

            if (match) {
                value = 0;
                var first = match[0];
                var firstOp = match[1];
                var second = match[2];
                var secondOp = match[3];
                if (parseInt(first) != NaN) {
                    if (firstOp == "\"") {
                        value += parseInt(first);
                    }
                    else {
                        value += (parseInt(first) * 12);
                    }
                }
                if (parseInt(second) != NaN) {
                    if (secondOp == "\"") {
                        value += parseInt(second);
                    }
                    else {
                        value += (parseInt(second) * 12);
                    }
                }
            }
        }

        else if (valueInput.hasClass("cerulean-calcstat")) {
            var nature = row.find(".j-nature").val();
            if (value) {
                if (nature == "2") {
                    value = Math.round(parseFloat(value) / 1.1);
                }
                else if (nature == "3") {
                    value = Math.round(parseFloat(value) / 0.9);
                }
            }
        }

        if (value) {
            data["filter-" + filter.Name + "-val"] = parseFloat(value);
            data["filter-" + filter.Name + "-op"] = comparator;
        }
        if (valueInput.hasClass("cerulean-calcstat")) {
            data["filter-" + filter.Name + "-nat"] = nature;
        }
    }



    function Deserialize() {
        var urlParams = GetUrlParams();

        var foundFilters = {};

        /* Deserialize */
        for (var filterName in urlParams) {
            filterName = filterName.substr("filter-".length);

            if (filterName == "")
                continue;

            /* Support for "num" */
            if (filterName.substr(filterName.length - "-val".length) == "-val")
                filterName = filterName.substr(0, filterName.length - "-val".length);

            /* Support for range */
            if (filterName.substr(filterName.length - "-min".length) == "-min")
                filterName = filterName.substr(0, filterName.length - "-min".length);

            if (filterName.substr(filterName.length - "-max".length) == "-max")
                filterName = filterName.substr(0, filterName.length - "-max".length);

            /* Support for "cerulean-enum" */
            if (filterName.substr(filterName.length - "-val1".length) == "-val1")
                filterName = filterName.substr(0, filterName.length - "-val1".length);

            /* Support for "dropdown2" */
            if (filterName.substr(filterName.length - "-1".length) == "-1")
                filterName = filterName.substr(0, filterName.length - "-1".length);

            var filter = FiltersByName[filterName];

            if (!filter)
                continue;

            if (foundFilters[filter.Name])
                continue;

            foundFilters[filter.Name] = true;

            var row = AddMainDropdown(filter.Name);

            DeserializeFilter(urlParams, filter, row);
        }
    }

    function DeserializeFilter(data, filter, row) {
        $.log(filter);
        var handler = DeserializeHandlers[filter.Type] || DeserializeDefault;

        handler(data, filter, row);
    }

    function DeserializeDefault(data, filter, row) {
        var val = data["filter-" + filter.Name];

        row.find(".filter-input").val(val);
    }

    function DeserializeNum(data, filter, row) {
        var valueInput = row.find(".j-value");
        var value = parseFloat(data["filter-" + filter.Name + "-val"]);

        if (valueInput.hasClass("cerulean-height")) {
            var feet = Math.floor(value / 12);
            var inches = value % 12;

            value = "";
            if (feet)
                value += feet + "'";
            if (inches || (inches == 0))
                value += inches + "\"";
        }
        else if (valueInput.hasClass("cerulean-calcstat")) {
            var nature = data["filter-" + filter.Name + "-nat"]
            if (value) {
                if (nature == "2") {
                    value = Math.round(parseFloat(value) * 1.1);
                }
                else if (nature == "3") {
                    value = Math.round(parseFloat(value) * 0.9);
                }
            }

        }
        row.find(".j-comparator").val(data["filter-" + filter.Name + "-op"]);
        row.find(".j-value").val(value);
        if (valueInput.hasClass("cerulean-calcstat")) {
            row.find(".j-nature").val(data["filter-" + filter.Name + "-nat"]);
        }
    }

    function DeserializeSymbolic(data, filter, row) {
        row.find("#filter-" + filter.Name + "-symbol").val(data["filter-" + filter.Name + "-" + "symbol"]);
        row.find("#filter-" + filter.Name + "-previous").val(data["filter-" + filter.Name + "-" + "previous"]);
        row.find("#filter-" + filter.Name).val(data["filter-" + filter.Name]);
    }

    function DeserializeRange(data, filter, row) {
        var minVal = data["filter-" + filter.Name + "-min"];
        var maxVal = data["filter-" + filter.Name + "-max"];

        row.find(".j-min-value").val(minVal);
        row.find(".j-max-value").val(maxVal);
    }

    function DeserializeDropdown2(data, filter, row) {
        var isEnum = false;
        $.log(filter);
        if (filter.Classes && filter.Classes.length > 0) {
            if ($.inArray("cerulean-enum", filter.Classes) > -1) {
                isEnum = true;
            }
            else {
                $.log(filter);
            }
        }
        if (isEnum) {
            var holder = row.find("select[data-value-id]");
            var givenValue = data["filter-" + filter.Name + "-" + "val1"];
            $.log(givenValue);
            $.log(holder[0]);
            if (givenValue) {
                $(holder[0]).val(givenValue);
            }
            var givenValue1 = data["filter-" + filter.Name + "-" + "op"];
            if (givenValue) {
                $(holder[1]).val(givenValue1);
            }
            var givenValue2 = data["filter-" + filter.Name + "-" + "val2"];
            if (givenValue) {
                $(holder[2]).val(givenValue2);
            }

        }
        else {
            row.find("select[data-value-id]").each(function () {
                var valueId = $(this).attr("data-value-id");
                var givenValue = data["filter-" + filter.Name + "-" + valueId];

                if (givenValue)
                    $(this).val(givenValue);
            });
        }
    }
}


function AppropriateFor(Data) {
    var Container = $("#appropriate-for");

    /* HTML Elements */
    var ClassSelector = null;
    var Separator = null;
    var SpecSelector = null;

    Initialize();

    /* Creates the html elements */
    function Initialize() {
        var urlParams = GetUrlParams();
        var selectedClass = parseInt(urlParams["filter-af"]);
        var selectedSpec = parseInt(urlParams["filter-af-spec"]);

        Container.html("");
        ClassSelector = $("<select/>").attr("name", "filter-af");
        Separator = $("<span/>").addClass("sep").text(" – ").hide();
        SpecSelector = $("<select/>").attr("name", "filter-af-spec").hide();

        ClassSelector.append("<option></option>");
        SpecSelector.append("<option></option>");

        for (var i = 0; i < Data.length; ++i) {
            var classData = Data[i].Class;
            var option = $("<option/>").attr("value", classData.Id).text(classData.Name);

            if (classData.Id == selectedClass)
                option.attr("selected", "selected");

            ClassSelector.append(option);
        }

        ClassSelector.change(function () { OnClassSelectorChange(); });
        ClassSelector.keyup(function () { OnClassSelectorChange(); });

        OnClassSelectorChange(selectedSpec);

        Container.append(ClassSelector).append(" ").append(Separator).append(" ").append(SpecSelector);
    }

    function OnClassSelectorChange(selectedSpec) {
        if (ClassSelector.data("last-value") == ClassSelector.val())
            return;

        ClassSelector.data("last-value", ClassSelector.val());
        var specData = GetSpecDataByClassId(parseInt(ClassSelector.val()));

        if (!specData) {
            Separator.hide();
            SpecSelector.hide();
            SpecSelector.html("");
            return;
        }

        SpecSelector.html("<option></option>");
        for (var i = 0; i < specData.length; ++i) {
            var option = $("<option/>").attr("value", i + 1).text(specData[i]);

            if (selectedSpec == i + 1)
                option.attr("selected", "selected");

            SpecSelector.append(option);
        }

        Separator.css("display", "inline-block");
        SpecSelector.css("display", "inline-block");
    }

    function GetSpecDataByClassId(classId) {
        if (!classId)
            return null;

        for (var i = 0; i < Data.length; ++i) {
            if (Data[i].Class.Id == classId)
                return Data[i].Specs;
        }

        return null;
    }
}


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Filters.js